export default {
  home: '首页',
  index: '首页',
};
